import {
  ChartTooltip,
} from "../../assets/GlobalStyles";
import {ResponsiveLine} from '@nivo/line'
import React, {useCallback, useEffect, useMemo, useState} from "react";
import styled from "styled-components";
import {toast} from "react-toastify";
import {useAtom,useAtomValue} from "jotai";
import {dataTotalInfo} from "../../components/common/entity";
import {chartDataAtom, commonProperties} from "./entity/Chart";
import {
  adverStatusAtom,
  adverStatusDetailAtom,
  adverStatusDetailColumn,
  userCampaignListColumn,
} from "./entity/Campaign";
import {productType, searchConditionAtom} from "./entity/Common";
import {
  retrieveAdverOverview,
  retrieveOverview,
} from "../../services/dash_board/ChartAxios";
import {
  overviewCacheAtom,
  selectedAdverIdsAtom,
  tokenResultAtom
} from "../login/entity/Common";
import {
  retrieveAdvertiserCampaignStatus,
  retrieveAdvertiserStatus, retrieveUserAdvertiserCampaignStatus
} from "../../services/dash_board/ManageCampaignAxios";
import {dateFormat, decimalFormat, moneyToFixedFormat, numberToFixedFormat} from "../../common/StringUtils";
import {DashBoardCondition} from "../../components/dashBoard/Condition";
import Table from "../../components/table";
import CampaignListTable from "../../components/table/CampaignListTable";
import AdvertiserListTable from "../../components/table/AdvertiserListTable";
import {selNoticeList} from "../../services/notice/NoticeAxios";
import NoticeTable from "../../components/table/NoticeTable";
import {columnNoticeDashboard} from "../customer/entity/NoticeEntity";
import {useNavigate} from "react-router-dom";
import {KPI_CHART_COLORS} from "../../common/ChartColors";
import SwitchComponent from "../../components/switch";
import {updateAdverCampaignPublish} from "../../services/campaign/CreativeAxios";
import {retrieveCommonReportsDetailByAdverCampId} from "../../services/reports/ReportsAxios";
import {retrieveCommonReportsAdminDetailByAdverCampId} from "../../services/reports/ReportsAdminAxios";

const getCampaignDailyRequestCondition = searchCondition => {
  const startDate = new Date(searchCondition?.searchStartDate);
  const endDate = new Date(searchCondition?.searchEndDate);
  const hasValidPeriod =
      !Number.isNaN(startDate.getTime()) &&
      !Number.isNaN(endDate.getTime()) &&
      endDate >= startDate;
  const periodDays = hasValidPeriod
      ? Math.floor((endDate - startDate) / 86400000) + 1
      : 31;

  return {
    ...searchCondition,
    pageSize: Math.max(1, periodDays),
    currentPage: 1,
    productType: searchCondition?.productType || null,
    deviceType: searchCondition?.deviceType || null,
    inventoryId: searchCondition?.inventoryId || null,
    agentTypes: null,
    deviceTypes: null
  };
};

const getDashboardCampaignColumns = isNormalUser => [
  ...adverStatusDetailColumn
  .filter(column =>
      ["publishYn", "campaignName", "exposureCount", "costAmount"].includes(column.name)
  )
  .map(column => {
    if (column.name !== "publishYn" || !isNormalUser) {
      return column;
    }

    return {
      ...column,
      render: ({value, cellProps}) => {
        const valueYn = value === "Y";
        return (
            <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
              <SwitchComponent
                  value={valueYn}
                  type="publish"
                  cellProps={cellProps}
                  eventClick={() => updateAdverCampaignPublish(
                      cellProps.data.campaignId,
                      !valueYn
                  )}
              />
            </div>
        );
      }
    };
  }),
  {
    name: "ecpm",
    header: "CPV",
    minWidth: 82,
    textAlign: "right",
    showColumnMenuTool: false,
    render: ({data}) => {
      const exposureCount = Number(data?.exposureCount ?? 0);
      const cpv = exposureCount > 0
          ? (Number(data?.costAmount ?? 0) / exposureCount) * 1000
          : 0;
      return `${numberToFixedFormat(cpv)}원`;
    }
  },
  {
    name: "allowInventorys",
    header: "노출 지면 수",
    minWidth: 96,
    textAlign: "right",
    showColumnMenuTool: false,
    render: ({value}) => `${Array.isArray(value) ? value.length : Number(value ?? 0)}개`
  }
];

/** 공지사항 **/
function NoticeUser () {
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const navigate = useNavigate();

  const [isSearch, setIsSearch] = useState(false);
  const [noticeRowCount, setNoticeRowCount] = useState(1);

  const [searchCondition, setSearchCondition] = useState(
      {keyword:'', pageSize: 3, currentPage: 1, publishYn:'ALL'});

  const loadData = ({skip, limit}) => {
    let params = {
      ...searchCondition,
      currentPage: skip/limit + 1,
      pageSize: limit
    }

    if(tokenUserInfo.role === 'NORMAL') {
      return selNoticeList({...params, publishYn: 'Y'}).then(response => {
        const notices = (
            Array.isArray(response?.content)
                ? response.content
                : Array.isArray(response?.rows)
                    ? response.rows
                    : []
        ).slice(0, 3);
        const totalCount = response?.totalElements ?? response?.totalCount ?? notices.length;
        setIsSearch(false);
        setNoticeRowCount(Math.min(3, Math.max(1, notices.length)));
        return {data: notices, count: Number(totalCount)};
      })
    }
  }

  const dataSource = useCallback(loadData, [searchCondition.currentPage, isSearch])
  return (
      <DashboardNoticeCard>
        <DashboardNoticeHeader>
          <PanelTitleArea>
            <PanelAccent/>
            <div>
              <PanelTitle>공지사항</PanelTitle>
              <PanelDescription>서비스 운영과 관련된 최신 안내를 확인합니다.</PanelDescription>
            </div>
          </PanelTitleArea>
          <NoticeAllButton type="button" onClick={() => navigate("/board/notice")}>
            전체보기 <span aria-hidden="true">&gt;</span>
          </NoticeAllButton>
        </DashboardNoticeHeader>
        <DashboardNoticeBody>
          <NoticeTable
              columns={tokenUserInfo.role !== 'NORMAL' ? columnNoticeDashboard : columnNoticeDashboard.filter(column => column.name !== 'publishYn')}
              defaultLimit={searchCondition.pageSize}
              data={dataSource}
              rowHeight={44}
              style={{
                height: noticeRowCount * 44,
                minHeight: noticeRowCount * 44,
                maxHeight: 3 * 44,
                textAlign: 'start'
              }}
              pagination={false}
              livePagination={false}
          />
        </DashboardNoticeBody>
      </DashboardNoticeCard>
  )
}

/** 플래폼 현황 차트 **/
function ChartComponent({campaignData = [], advertiserCount = 0, campaignCount = 0, statusContent = null, periodControl = null, selectionControl = null, campaignSelected = false}) {
  const [tokenUserInfo] = useAtom(tokenResultAtom)
  const [chartData, setChartData] = useState(chartDataAtom);
  const searchCondition = useAtomValue(searchConditionAtom)
  const [dataType, setDataType] = useState('')
  const [dataType2, setDataType2] = useState('')
  const [chartDataInfo, setChartDataInfo] = useState([])
  const [chartList, setChartList] = useState([])
  const [comparisonMetricKey, setComparisonMetricKey] = useState("exposureCount")
  const overviewCache = useAtomValue(overviewCacheAtom)
  const selectedIds = useAtomValue(selectedAdverIdsAtom)

  useEffect(()=>{
    if(tokenUserInfo.role !== '') {
      if(tokenUserInfo.role !== 'NORMAL') {
        let data = overviewCache  ?? [];
        if (!campaignSelected && selectedIds.size > 0) {
          data = data.filter(item => selectedIds.has(item.userId))
        }
        const computed = data.map(item => {
          const exposureCount = item.exposureCount ?? 0
          const validClickCount = item.validClickCount ?? 0
          const costAmount = item.costAmount ?? 0
          const totalConversionCount = item.totalConversionCount ?? 0
          const totalConversionAmount = item.totalConversionAmount ?? 0
          const sessionConversionAmount = item.sessionConversionAmount ?? 0
          const directConversionAmount = item.directConversionAmount ?? 0
          return {
            ...item,
            clickRate: exposureCount !== 0 ? (validClickCount / exposureCount) * 100 : 0,
            cpc: validClickCount !== 0 ? costAmount / validClickCount : 0,
            costPerConversion: totalConversionCount !== 0 ? costAmount / totalConversionCount : 0,
            avgConversionAmount: totalConversionCount !== 0 ? totalConversionAmount / totalConversionCount : 0,
            sessionRoas: costAmount !== 0 ? (sessionConversionAmount / costAmount) * 100 : 0,
            directRoas: costAmount !== 0 ? (directConversionAmount / costAmount) * 100 : 0,
            totalRoas: costAmount !== 0 ? (totalConversionAmount / costAmount) * 100 : 0,
            ecpm: exposureCount !== 0 ? (costAmount / exposureCount) * 1000 : 0,
            conversionRate: validClickCount !== 0 ? (totalConversionCount / validClickCount) * 100 : 0,
          }
        })
        const filled = fillMissingDailyRows(computed, searchCondition);
        setChartDataInfo(filled)
      } else {
        let data =  overviewCache  ?? [];
        if(data !== null) {
          data?.map((item,key) => {
            Object.assign(data[key],{clickRate: item.validClickCount !== 0 ? (item.validClickCount / item.exposureCount) *100 : 0})
            Object.assign(data[key],{cpc:item.validClickCount !== 0 ? item?.costAmount / item.validClickCount : 0})
            Object.assign(data[key],{costPerConversion: item.totalConversionCount !== 0 ? item?.costAmount / item.totalConversionCount : 0})
            Object.assign(data[key],{avgConversionAmount: item.totalConversionAmount !== 0 ? item.totalConversionAmount / item.totalConversionCount : 0})
            Object.assign(data[key],{totalRoas: item.totalConversionAmount !== 0 ? (item.totalConversionAmount / item.costAmount) *100 : 0})
            Object.assign(data[key],{ecpm: item.exposureCount !== 0 ? (item?.costAmount / item.exposureCount) *1000 : 0})
            Object.assign(data[key],{conversionRate: item.totalConversionCount !== 0 ? (item.totalConversionCount / item.validClickCount) *100 : 0})
            Object.assign(data[key],{allowInventorys: item.allowInventorys})
            return null
          })
          const filled = fillMissingDailyRows(data ?? [], searchCondition)
          setChartDataInfo(filled)
        }
      }
    }
  },[tokenUserInfo.id, tokenUserInfo.role, searchCondition, overviewCache, selectedIds, campaignSelected])

  useEffect(() => {
    makeChartData()
  }, [chartData,chartDataInfo]);

  function _toYmd(d) {
    const yyyy = d.getFullYear()
    const mm = String(d.getMonth() + 1).padStart(2, '0')
    const dd = String(d.getDate()).padStart(2, '0')
    return `${yyyy}-${mm}-${dd}`
  }

  function _parseToDate(v) {
    if (!v) return null
    // 'YYYY-MM-DD' 또는 Date 모두 대응
    if (v instanceof Date) return v
    return new Date(String(v).slice(0, 10))
  }

  function fillMissingDailyRows(rows, searchCondition) {
    const src = Array.isArray(rows) ? rows : []
    if (src.length === 0) return src

    const key = 'historyDate'
    const from = _parseToDate(searchCondition?.searchStartDate)
    const to = _parseToDate(searchCondition?.searchEndDate)

    let minD = from
    let maxD = to

    if (!minD || !maxD) {
      const dates = src
      .map(r => _parseToDate(r?.[key]))
      .filter(Boolean)
      .sort((a, b) => a - b)

      minD = minD || dates[0]
      maxD = maxD || dates[dates.length - 1]
    }

    if (!minD || !maxD) return src

    // ✅ 합산 대상 필드(원본 + 파생지표 포함 가능)
    const sumFields = [
      'exposureCount',
      'totalExposureCount',
      'validClickCount',
      'totalClickCount',
      'sessionConversionCount',
      'directConversionCount',
      'exposureConversionCount',
      'totalConversionCount',
      'costAmount',
      'sessionConversionAmount',
      'directConversionAmount',
      'exposureConversionAmount',
      'totalConversionAmount',
      // 파생지표를 rows에 이미 넣어놨다면, 여기 합산은 비추천(재계산이 맞음)
      // 'clickRate', 'cpc', ...
    ]

    const byYmd = new Map()

    // ✅ 같은 날짜면 누적 합산
    for (const r of src) {
      const d = _parseToDate(r?.[key])
      if (!d) continue
      const ymd = _toYmd(d)

      const prev = byYmd.get(ymd)
      if (!prev) {
        const base = {
          ...r,
          [key]: ymd,
          allowInventorys: [...(r?.allowInventorys ?? [])],
        };

        for (const f of sumFields) {
          base[f] = Number(base[f] ?? 0);
        }

        byYmd.set(ymd, base);
        continue;
      }

      // 누적
      for (const f of sumFields) {
        prev[f] = Number(prev[f] ?? 0) + Number(r?.[f] ?? 0)
      }
      const mergedAllowInventorys = [
        ...(prev.allowInventorys ?? []),
        ...(r?.allowInventorys ?? []),
      ];

      const seen = new Set();
      prev.allowInventorys = mergedAllowInventorys.filter((item) => {
        const inventoryId = item?.inventoryId;
        if (inventoryId == null) return false;
        if (seen.has(inventoryId)) return false;
        seen.add(inventoryId);
        return true;
      });
    }

    const out = []
    for (let d = new Date(minD); d <= maxD; d.setDate(d.getDate() + 1)) {
      const ymd = _toYmd(d)
      const hit = byYmd.get(ymd)

      if (hit) {
        out.push(hit)
      } else {
        out.push({
          [key]: ymd,
          exposureCount: 0,
          totalExposureCount: 0,
          validClickCount: 0,
          totalClickCount: 0,
          sessionConversionCount: 0,
          directConversionCount: 0,
          exposureConversionCount: 0,
          totalConversionCount: 0,
          costAmount: 0,
          sessionConversionAmount: 0,
          directConversionAmount: 0,
          exposureConversionAmount: 0,
          totalConversionAmount: 0,
        })
      }
    }

    return out
  }

  function calculateSum(property) {
    function calculatePropertySum(property) { // 전체 값은 따로 계산식 함수로 값 정리
      return chartDataInfo.reduce((prev, next) => prev + next[property], 0);
    }

    //[d] 개별 계산값 정리
    const clickCountSum = calculatePropertySum('validClickCount');
    const exposureCountSum = calculatePropertySum('exposureCount');
    const costAmountSum = calculatePropertySum('costAmount');
    const totalConversionCountSum = calculatePropertySum('totalConversionCount');
    const totalConversionAmountSum = calculatePropertySum('totalConversionAmount');
    const sessionConversionAmountSum = calculatePropertySum('sessionConversionAmount');
    const directConversionAmountSum = calculatePropertySum('directConversionAmount');
    //const exposureConversionAmountSum = calculatePropertySum('exposureConversionAmount');

    //[d] 개별 계산값을 포함한 개별 공식 계싼값 switch 문으로 구성
    let calc = 0;
    switch (property) {
      case 'validClickCount':
      case 'exposureCount':
      case 'totalConversionCount':
      case 'userCount':
      case 'totalExposureCount':
      case 'totalClickCount':
      case 'costAmount':
      case 'sessionConversionAmount':
      case 'directConversionAmount':
      case 'exposureConversionAmount':
      case 'totalConversionAmount':
        calc = chartDataInfo.reduce((prev, next) => prev + next[property], 0);
        break;
      case 'clickRate':
        const caseValueA = exposureCountSum;
        calc = caseValueA !== 0 ? (clickCountSum / exposureCountSum) * 100 : 0;
        break;
      case 'cpc':
        const caseValueB = costAmountSum;
        calc = caseValueB !== 0 ? caseValueB / clickCountSum  : 0;
        break;
      case 'conversionRate':
        const caseValueC = clickCountSum;
        calc = caseValueC !== 0 ? (totalConversionCountSum / clickCountSum) * 100 : 0;
        break;
      case 'costPerConversion':
        const caseValueD = totalConversionCountSum;
        calc = caseValueD !== 0 ? costAmountSum / totalConversionCountSum : 0;
        break;
      case 'avgConversionAmount':
        const caseValueE = totalConversionAmountSum;
        calc = caseValueE !== 0 ? totalConversionAmountSum / totalConversionCountSum : 0;
        break;
      case 'sessionRoas':
        const caseValueF = costAmountSum;
        calc = caseValueF !== 0 ? (sessionConversionAmountSum / costAmountSum) * 100 : 0;
        break;
      case 'directRoas':
        const caseValueG = costAmountSum;
        calc = caseValueG !== 0 ? (directConversionAmountSum / costAmountSum) * 100 : 0;
        break;
        // case 'exposureRoas':
        //   const caseValueH = costAmountSum;
        //   calc = caseValueH !== 0 ? (exposureConversionAmountSum / costAmountSum) * 100 : 0;
        //   break;
      case 'totalRoas':
        const caseValueI = costAmountSum;
        calc = caseValueI !== 0 ? (totalConversionAmountSum / costAmountSum) * 100 : 0;
        break;
      case 'ecpm':
        const caseValueJ = exposureCountSum;
        calc = caseValueJ !== 0 ? (costAmountSum / exposureCountSum) * 1000 : 0;
        break;
      case 'allowInventorys':
        let inventoryCount = new Set(
            (chartDataInfo ?? [])
            .flatMap((item) => item?.allowInventorys ?? [])
            .map((d) => d.inventoryId)
            .filter((v) => v != null)
        ).size;
        calc = inventoryCount;
        break;
      default:
        break;
    }

    let value;
    if (['clickRate','conversionRate','sessionRoas','directRoas','totalRoas'].includes(property)) {
      value = numberToFixedFormat(calc)+'%'
    } else if(['validClickCount','exposureCount','totalConversionCount','userCount','totalExposureCount','totalClickCount'].includes(property)) {
      value = decimalFormat(calc)
    } else if(['allowInventorys'].includes(property)) {
      value = decimalFormat(calc)
    } else {
      value = moneyToFixedFormat(calc)+' 원'
    }
    return value
  }

  const handleOnChangeChartStatus = (statusId) => {
    setChartData({
      ...chartData,
      [statusId]: {
        ...chartData[statusId],
        status: !chartData[statusId].status
      }
    })
  }

  //[d] dataType, dataType2 값에 따라 3개 고정값 status 및 서로 선택한 기본 상태는 유지
  const handleChangeDataType = (e) => {
    setChartData((prevChartData) => {
      const newData = {};
      Object.keys(prevChartData).forEach((key) => {
        newData[key] = {
          ...prevChartData[key],
          status:
              key === e.value || (['validClickCount', 'exposureCount', 'totalConversionCount'].includes(key) &&
                  prevChartData[key].status) || (prevChartData[key].status && key === dataType2),
        };
      });
      return newData;
    });
    setDataType(e.value);
  };

  const handleChangeDataType2 = (e) => {
    setChartData((prevChartData) => {
      const newData = {};
      Object.keys(prevChartData).forEach((key) => {
        newData[key] = {
          ...prevChartData[key],
          status:
              key === e.value || (['validClickCount', 'exposureCount', 'totalConversionCount'].includes(key) &&
                  prevChartData[key].status) || (prevChartData[key].status && key === dataType),
        };
      });
      return newData;
    });
    setDataType2(e.value);
  };

  //[d] chartData 객체에 담았던 컬러 값 필요없이 고정 컬러값 5개로 재구성 기획자 요청 색상!!
  const fixedColors = [
    KPI_CHART_COLORS.exposureCount,
    KPI_CHART_COLORS.costAmount,
    KPI_CHART_COLORS.cpv,
    KPI_CHART_COLORS.allowInventorys,
    '#e66a7a'
  ];
  const makeChartData = () => {
    let list = [];
    Object.entries(chartData).map(([id,key], index) => {
      if(chartData[id].status){
        let colorIndex;
        //[d] 3개 고정값 외 셀렉트 박스로 선택하는 값은 id === dataType 매칭으로 고정색상 사용
        if (id === dataType) {
          colorIndex = 3;
        } else if (id === dataType2) {
          colorIndex = 4;
        } else {
          colorIndex = index % fixedColors.length;
        }
        list.push({
          id: id,
          data: chartDataInfo.map(item => {
            const date = new Date(item?.historyDate);
            const formattedDate = dateFormat(date, 'MM/DD');
            const dateColor = dateFormat(date, 'ddd').includes('Sun') && 'red';
            if(id === 'allowInventorys') {
              let inventoryCount = new Set(
                  (item[id] ?? [])
                  .map((d) => d.inventoryId)
                  .filter((v) => v != null)
              ).size;
              return {color: dateColor, tooltipDate: dateFormat(date, 'YYYY.MM.DD'), x: formattedDate, y: isNaN(inventoryCount) ? 0 : inventoryCount}
            } else {
              return {color: dateColor, tooltipDate: dateFormat(date, 'YYYY.MM.DD'), x: formattedDate, y: isNaN(item[id]) ? 0 : item[id]}
            }
          }),
          color: fixedColors[colorIndex],
          order: colorIndex
        })
      }
      return null
    })
    setChartList(list.sort((a,b) => {if(a.order>b.order){return -1}else{return 1}}))
  }


  const yFormatted = (data) => {
    let value;
    if (['clickRate','conversionRate','sessionRoas','directRoas','totalRoas'].includes(data.serieId)) {
      value = numberToFixedFormat(data.data.y)+'%'
    } else if(['validClickCount','exposureCount','totalConversionCount','userCount','totalExposureCount','totalClickCount'].includes(data.serieId)) {
      value = decimalFormat(data.data.y)
    } else if(['allowInventorys'].includes(data.serieId)) {
      value = decimalFormat(data.data.y)
    } else {
      value = moneyToFixedFormat(data.data.y)+'원'
    }
    return value
  }

  const formatYAxisValue = value => {
    return decimalFormat(Math.round(Number(value) || 0));
  };
  const ChartMetricCard = ({
    label,
    active,
    onClick,
    color
  }) => (
      <MetricCard
          type="button"
          $active={active}
          $seriesColor={color}
          aria-pressed={active}
          onClick={onClick}
      >
        <MetricLabelGroup>
          <MetricColorDot
              $active={active}
              $seriesColor={color}
          />
          <MetricLabel>{label}</MetricLabel>
        </MetricLabelGroup>
      </MetricCard>
  );

  const hasChartData =
      chartList.some(series =>
          Array.isArray(series?.data) &&
          series.data.length > 0
      );

  const comparisonCampaigns = useMemo(
      () => Array.isArray(campaignData) ? campaignData : [],
      [campaignData]
  );

  const comparisonMetrics = [
    {key: "exposureCount", label: "노출수", unit: "회", value: item => Number(item?.exposureCount ?? 0)},
    {key: "costAmount", label: "비용", unit: "원", value: item => Number(item?.costAmount ?? 0)},
    {
      key: "cpv",
      label: "CPV",
      unit: "원",
      value: item => {
        const exposureCount = Number(item?.exposureCount ?? 0);
        const costAmount = Number(item?.costAmount ?? 0);
        return exposureCount > 0 ? (costAmount / exposureCount) * 1000 : 0;
      }
    }
  ];

  const selectedComparisonMetric =
      comparisonMetrics.find(metric => metric.key === comparisonMetricKey) ??
      comparisonMetrics[0];

  const rankedComparisonCampaigns = comparisonCampaigns
  .map(campaign => ({
    campaign,
    value: selectedComparisonMetric.value(campaign)
  }))
  .filter(item => Number.isFinite(item.value))
  .sort((first, second) => second.value - first.value)
  .slice(0, 5);

  const comparisonMaximum = Math.max(
      ...rankedComparisonCampaigns.map(item => item.value),
      1
  );

  return (
      <PlatformStatusContent>
        <DashboardFilterRow>
          {selectionControl}
          {periodControl}
        </DashboardFilterRow>
        {statusContent}
        <DashboardOverviewRow>
        <DashboardSummaryGrid>
          <DashboardSummaryCard $tone="orange">
            <SummaryCardHeader><SummaryCardIcon $tone="orange"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5c5.5 0 9.5 5.1 9.5 7s-4 7-9.5 7S2.5 13.9 2.5 12 6.5 5 12 5Zm0 2c-4.05 0-7.1 3.55-7.46 5 .36 1.45 3.41 5 7.46 5s7.1-3.55 7.46-5C19.1 10.55 16.05 7 12 7Zm0 2.5A2.5 2.5 0 1 1 12 14a2.5 2.5 0 0 1 0-5Z"/></svg></SummaryCardIcon><SummaryCardLabel>노출수</SummaryCardLabel></SummaryCardHeader>
            <SummaryCardValue>{calculateSum("exposureCount")}</SummaryCardValue>
            <SummaryCardGuide>조회 기간 합계</SummaryCardGuide>
          </DashboardSummaryCard>
          <DashboardSummaryCard $tone="blue">
            <SummaryCardHeader><SummaryCardIcon $tone="blue"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 4h16v16H4V4Zm2 2v12h12V6H6Zm2 2h2l2 3 2-3h2l-2.67 4H16v2h-3v2h-2v-2H8v-2h2.67L8 8Z"/></svg></SummaryCardIcon><SummaryCardLabel>비용</SummaryCardLabel></SummaryCardHeader>
            <SummaryCardValue>{calculateSum("costAmount")}</SummaryCardValue>
            <SummaryCardGuide>조회 기간 합계</SummaryCardGuide>
          </DashboardSummaryCard>
          <DashboardSummaryCard $tone="green">
            <SummaryCardHeader><SummaryCardIcon $tone="green"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 3h14v18H5V3Zm2 2v4h10V5H7Zm0 6v2h2v-2H7Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Zm-8 4v2h2v-2H7Zm4 0v2h2v-2h-2Zm4 0v2h2v-2h-2Z"/></svg></SummaryCardIcon><SummaryCardLabel>CPV</SummaryCardLabel></SummaryCardHeader>
            <SummaryCardValue>{calculateSum("ecpm")}</SummaryCardValue>
            <SummaryCardGuide>비용 ÷ 노출수 × 1,000</SummaryCardGuide>
          </DashboardSummaryCard>
          <DashboardSummaryCard $tone="purple">
            <SummaryCardHeader><SummaryCardIcon $tone="purple"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h18v16H3V4Zm2 2v5h6V6H5Zm8 0v5h6V6h-6Zm-8 7v5h6v-5H5Zm8 0v5h6v-5h-6Z"/></svg></SummaryCardIcon><SummaryCardLabel>노출 지면 수</SummaryCardLabel></SummaryCardHeader>
            <SummaryCardValue>{calculateSum("allowInventorys")}</SummaryCardValue>
            <SummaryCardGuide>조회 기간 내 고유 지면</SummaryCardGuide>
          </DashboardSummaryCard>
        </DashboardSummaryGrid>
        <CampaignComparisonPanel>
          <ChartPanelHeader>
            <ChartPanelTitleGroup>
              <ComparisonTitleRow>
                <ChartPanelTitle>캠페인별 성과 비교</ChartPanelTitle>
                <ActiveMetricCount>TOP 5</ActiveMetricCount>
              </ComparisonTitleRow>
              <ChartPanelDescription>선택한 성과 지표를 기준으로 상위 캠페인을 비교합니다.</ChartPanelDescription>
            </ChartPanelTitleGroup>
            <ComparisonHeaderControls>
              <ComparisonMetricSelect
                  value={comparisonMetricKey}
                  onChange={event => setComparisonMetricKey(event.target.value)}
                  aria-label="캠페인 성과 지표 선택"
              >
                {comparisonMetrics.map(metric => (
                    <option key={metric.key} value={metric.key}>
                      {metric.label}
                    </option>
                ))}
              </ComparisonMetricSelect>
            </ComparisonHeaderControls>
          </ChartPanelHeader>
          {rankedComparisonCampaigns.length > 0 ? (
              <CampaignMetricGrid>
                <CampaignMetricGroup>
                  <CampaignMetricTitle>
                    <strong>{selectedComparisonMetric.label} TOP 5</strong>
                    <span>{selectedComparisonMetric.unit}</span>
                  </CampaignMetricTitle>
                  <CampaignBars>
                    {rankedComparisonCampaigns.map(({campaign, value}, index) => {
                      const graphWidth = Math.min(100, Math.max(0, value / comparisonMaximum * 100));
                      const endY = Math.max(4, 20 - graphWidth * .13);
                      return (
                          <CampaignBarRow key={campaign?.campaignId ?? `${selectedComparisonMetric.key}-${index}`}>
                            <CampaignRank $rank={index}>{index + 1}</CampaignRank>
                            <CampaignNameGroup>
                              <CampaignBarName title={campaign?.campaignName}>{campaign?.campaignName ?? "-"}</CampaignBarName>
                              <CampaignAdvertiserName title={campaign?.adverName ?? campaign?.adverInfo}>
                                {campaign?.adverName ?? campaign?.adverInfo?.split("(")?.[0] ?? "-"}
                              </CampaignAdvertiserName>
                            </CampaignNameGroup>
                            <CampaignBarValue>
                              {selectedComparisonMetric.key === "cpv" ? numberToFixedFormat(value) : decimalFormat(value)}
                            </CampaignBarValue>
                            <CampaignMiniChart $rank={index} aria-hidden="true">
                              <svg viewBox="0 0 90 24" preserveAspectRatio="none">
                                <polyline points={`2,20 17,17 32,19 47,12 62,14 76,8 88,${endY}`} />
                              </svg>
                            </CampaignMiniChart>
                          </CampaignBarRow>
                      );
                    })}
                  </CampaignBars>
                </CampaignMetricGroup>
              </CampaignMetricGrid>
          ) : (
              <ComparisonEmpty>광고주를 선택하면 캠페인별 성과 비교 차트가 표시됩니다.</ComparisonEmpty>
          )}
        </CampaignComparisonPanel>
        </DashboardOverviewRow>
        <ChartPanel>
          <ChartPanelHeader>
            <ChartPanelTitleGroup>
              <ChartPanelTitle>
                기간별 지표 추이
              </ChartPanelTitle>

              <ChartPanelDescription>
                활성화된 지표의 일자별 변화를 확인합니다.
              </ChartPanelDescription>
            </ChartPanelTitleGroup>

          </ChartPanelHeader>
          <MetricGrid>
            <ChartMetricCard
                label="노출수"
                active={chartData["exposureCount"].status}
                onClick={() =>
                    handleOnChangeChartStatus("exposureCount")
                }
                color={fixedColors[0]}
            />

            <ChartMetricCard
                label="비용"
                active={chartData["costAmount"].status}
                onClick={() =>
                    handleOnChangeChartStatus("costAmount")
                }
                color={fixedColors[1]}
            />

            <ChartMetricCard
                label="CPV"
                active={chartData["ecpm"].status}
                onClick={() =>
                    handleOnChangeChartStatus("ecpm")
                }
                color={fixedColors[2]}
            />

            <ChartMetricCard
                label="노출지면 수"
                active={chartData["allowInventorys"].status}
                onClick={() =>
                    handleOnChangeChartStatus("allowInventorys")
                }
                color={fixedColors[3]}
            />
          </MetricGrid>
          <ChartArea>
            {hasChartData ? (
                <ResponsiveLine
                    {...commonProperties}
                    margin={{top: 24, right: 24, bottom: 42, left: 68}}
                    data={chartList}
                    colors={series => series.color}
                    lineWidth={2}
                    pointSize={6}
                    pointColor="#fff"
                    pointBorderWidth={2}
                    pointBorderColor={{from: "serieColor"}}
                    enableGridY={true}
                    gridYValues={5}
                    axisLeft={{
                      tickSize: 0,
                      tickPadding: 10,
                      tickRotation: 0,
                      tickValues: 5,
                      format: formatYAxisValue
                    }}
                    theme={{
                      axis: {
                        ticks: {text: {fill: "#8b929a", fontSize: 12}},
                        legend: {text: {fill: "#68717a", fontSize: 12, fontWeight: 700}}
                      },
                      grid: {line: {stroke: "#edf0f2", strokeWidth: 1}}
                    }}
                    sliceTooltip={props => (
                        <ChartTooltip>
                          <p className="date">
                            {
                              props.slice.points[0]
                                  ?.data?.tooltipDate
                            }
                          </p>

                          {props.slice.points.map(
                              (data, key) => (
                                  <p key={key}>
                                    <span
                                        style={{
                                          color:
                                          data.serieColor
                                        }}
                                    >
                                      {
                                        chartData[
                                            data.serieId
                                            ]?.label
                                      }
                                      {" : "}
                                    </span>

                                    <span>
                                      {yFormatted(data)}
                                    </span>
                                  </p>
                              )
                          )}
                        </ChartTooltip>
                    )}
                />
            ) : (
                <ChartEmptyState>
                  <ChartEmptyIcon aria-hidden="true">
                    <svg
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                    >
                      <path
                          fill="currentColor"
                          d="M4 19V5h2v12h14v2H4Zm4-4V9h2v6H8Zm4 0V5h2v10h-2Zm4 0v-4h2v4h-2Z"
                      />
                    </svg>
                  </ChartEmptyIcon>

                  <ChartEmptyTitle>
                    표시할 차트 데이터가 없습니다.
                  </ChartEmptyTitle>

                  <ChartEmptyDescription>
                    조회 조건이나 선택한 광고주를 확인해주세요.
                  </ChartEmptyDescription>
                </ChartEmptyState>
            )}
          </ChartArea>
        </ChartPanel>
      </PlatformStatusContent>
  );
}

/** 광고주별 캠페인 현황 **/
function AdvertiserCampaignStatus({
  advertiserData,
  campaignData,
  selectedAdvertiser,
  selectedCampaign,
  isLoadingCampaigns,
  onSelectAdvertiser,
  onSelectCampaign
}) {
  const advertiserList = useMemo(
      () => Array.isArray(advertiserData) ? advertiserData : [],
      [advertiserData]
  );

  const campaignList = useMemo(
      () => Array.isArray(campaignData) ? campaignData : [],
      [campaignData]
  );

  return (
      <StatusLayout>
        <StatusSection>
          <StatusSectionHeader>
            <StatusTitleGroup>
              <div>
                <StatusTitle>광고주 목록</StatusTitle>
                <StatusDescription>
                  광고주를 선택해 캠페인을 확인하세요.
                </StatusDescription>
              </div>
            </StatusTitleGroup>

            <StatusCountBadge>
              {advertiserList.length}명
            </StatusCountBadge>
          </StatusSectionHeader>

          <AdvertiserListTable
              advertisers={advertiserList}
              selectedAdvertiserId={selectedAdvertiser?.userId}
              onAdvertiserSelect={onSelectAdvertiser}
              countKey="campaignCount"
          />
        </StatusSection>

        <StatusSection>
          <StatusSectionHeader>
            <StatusTitleGroup>
              <div>
                <StatusTitle>캠페인 목록</StatusTitle>
                <StatusDescription>
                  {selectedAdvertiser
                      ? `${selectedAdvertiser?.adverName ?? "-"}의 캠페인과 운영 상태를 확인하세요.`
                      : "상단 광고주 목록에서 광고주를 선택해주세요."}
                </StatusDescription>
              </div>
            </StatusTitleGroup>

            {selectedAdvertiser && (
                <SelectedAdvertiserSummary>
                  <SummaryLabel>선택 광고주</SummaryLabel>
                  <SummaryValue>
                    {selectedAdvertiser?.adverName ?? "-"}
                  </SummaryValue>
                  <SummaryDivider/>
                  <SummarySubValue>
                    {selectedAdvertiser?.username ?? "-"}
                  </SummarySubValue>
                </SelectedAdvertiserSummary>
            )}
          </StatusSectionHeader>

          <CampaignTableCard $active={Boolean(selectedAdvertiser)}>
            {!selectedAdvertiser ? (
                <CampaignEmptyState>
                  <EmptyIcon aria-hidden="true">
                    <svg
                        width="30"
                        height="30"
                        viewBox="0 0 24 24"
                    >
                      <path
                          fill="currentColor"
                          d="M4 5h16v14H4V5Zm2 2v10h12V7H6Zm2 2h8v2H8V9Zm0 4h5v2H8v-2Z"
                      />
                    </svg>
                  </EmptyIcon>

                  <EmptyTitle>광고주를 선택해주세요.</EmptyTitle>
                  <EmptyDescription>
                    광고주 행을 클릭하면 해당 광고주의 캠페인 목록이 표시됩니다.
                  </EmptyDescription>
                </CampaignEmptyState>
            ) : isLoadingCampaigns ? (
                <CampaignLoading>
                  <LoadingSpinner/>
                  <span>캠페인 정보를 불러오고 있습니다.</span>
                </CampaignLoading>
            ) : (
                <CampaignGridWrap>
                  <CampaignListTable
                      style={{
                        height: Math.min(
                            242,
                            Math.max(260, 42 + campaignList.length * 50)
                        )
                      }}
                      licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
                      handle={null}
                      clearNodeCacheOnDataSourceChange={true}
                      defaultSortInfo={{name: "costAmount", dir: -1}}
                      dataSource={campaignList}
                      columns={getDashboardCampaignColumns(false)}
                      enableColumnAutosize={true}
                      groups={false}
                      emptyText="완료된 캠페인이 없습니다."
                      rowHeight={50}
                      headerHeight={42}
                      showHoverRows={true}
                      activeCell={null}
                      idProperty="campaignId"
                      selectedCampaignId={selectedCampaign?.campaignId}
                      onCampaignSelect={onSelectCampaign}
                      minWidth={860}
                  />
                </CampaignGridWrap>
            )}
          </CampaignTableCard>
        </StatusSection>
      </StatusLayout>
  );
}

function UserCampaignStatus({campaignData, selectedCampaign, onSelectCampaign}) {
  const campaignList = Array.isArray(campaignData) ? campaignData : [];

  return (
      <StatusSection>
        <StatusSectionHeader>
          <StatusTitleGroup>
            <div>
              <StatusTitle>캠페인 목록</StatusTitle>
              <StatusDescription>
                완료된 캠페인의 운영 상태와 주요 성과를 확인할 수 있습니다.
              </StatusDescription>
            </div>
          </StatusTitleGroup>
          <StatusCountBadge>{campaignList.length}개</StatusCountBadge>
        </StatusSectionHeader>
        <CampaignTableCard $active>
          <CampaignGridWrap>
            <CampaignListTable
                style={{
                  height: Math.min(
                      342,
                      Math.max(260, 42 + campaignList.length * 50)
                  )
                }}
                licenseKey={process.env.REACT_APP_DATA_GRID_LICENSE_KEY}
                handle={null}
                clearNodeCacheOnDataSourceChange={true}
                defaultSortInfo={{name: "costAmount", dir: -1}}
                dataSource={campaignList}
                columns={getDashboardCampaignColumns(true)}
                enableColumnAutosize={true}
                groups={false}
                emptyText="완료된 캠페인이 없습니다."
                rowHeight={50}
                headerHeight={42}
                showHoverRows={true}
                activeCell={null}
                idProperty="campaignId"
                selectedCampaignId={selectedCampaign?.campaignId}
                onCampaignSelect={onSelectCampaign}
                minWidth={860}
            />
          </CampaignGridWrap>
        </CampaignTableCard>
      </StatusSection>
  );
}

/** 대시보드 **/
function DashBoardIndex() {
  const navigate = useNavigate();
  const [tokenUserInfo] = useAtom(tokenResultAtom);
  const [totalInfo, setTotalInfo] = useState(dataTotalInfo);
  const [adverStatusData, setAdverStatusData] = useAtom(adverStatusAtom);
  const [adverStatusDetailData, setAdverStatusDetailData] =
      useAtom(adverStatusDetailAtom);
  const [searchCondition, setSearchCondition] = useAtom(searchConditionAtom);
  const [searchState, setSearchState] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [, setOverviewCache] = useAtom(overviewCacheAtom);
  const [selectedIds, setSelectedIds] = useAtom(selectedAdverIdsAtom);

  const [selectedAdvertiser, setSelectedAdvertiser] = useState(null);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [isLoadingCampaigns, setIsLoadingCampaigns] = useState(false);
  const [allCampaignData, setAllCampaignData] = useState([]);

  useEffect(() => {
    const loadDashboard = async () => {
      if (!tokenUserInfo?.role) {
        return;
      }

      if (tokenUserInfo.role !== "NORMAL") {
        const selectedUserId = selectedAdvertiser?.userId;

        try {
          const [advertiserResponse, overviewResponse, selectedCampaignResponse] = await Promise.all([
            retrieveAdvertiserStatus(searchCondition),
            selectedCampaign?.campaignId && selectedUserId
                ? retrieveCommonReportsAdminDetailByAdverCampId(
                    tokenUserInfo.id,
                    getCampaignDailyRequestCondition(searchCondition),
                    "campaign_daily",
                    selectedUserId,
                    selectedCampaign.campaignId
                )
                : retrieveOverview(searchCondition),
            selectedUserId
                ? retrieveAdvertiserCampaignStatus(selectedUserId, searchCondition)
                : Promise.resolve([])
          ]);

          const advertisers = Array.isArray(advertiserResponse)
              ? advertiserResponse.filter(advertiser => advertiser?.status === "NORMAL")
              : [];

          const campaignResponses = await Promise.all(
              advertisers.map(advertiser =>
                  advertiser?.userId === selectedUserId
                      ? Promise.resolve(selectedCampaignResponse)
                      : retrieveAdvertiserCampaignStatus(advertiser?.userId, searchCondition)
              )
          );
          const allCampaigns = campaignResponses.flatMap((campaigns, index) => {
            const advertiser = advertisers[index];
            return (Array.isArray(campaigns) ? campaigns : []).map(campaign => ({
              ...campaign,
              userId: advertiser?.userId,
              adverName: advertiser?.adverName,
              adverInfo: `${advertiser?.adverName ?? "-"}(${advertiser?.username ?? "-"})`
            }));
          });

          setAdverStatusData(advertisers);
          setAllCampaignData(allCampaigns);
          setTotalInfo({
            totalCount: advertisers.length
          });
          setOverviewCache(
              selectedCampaign?.campaignId
                  ? (overviewResponse?.pagingCommonResponse?.content ?? []).map(item => ({
                    ...item,
                    historyDate: item?.historyDate ?? item?.statisticsDate
                  }))
                  : overviewResponse ?? []
          );

          if (selectedUserId) {
            const currentAdvertiser = advertisers.find(
                advertiser => advertiser?.userId === selectedUserId
            );
            const campaigns = Array.isArray(selectedCampaignResponse)
                ? selectedCampaignResponse
                : [];

            if (currentAdvertiser) {
              setSelectedAdvertiser(currentAdvertiser);
              setSelectedIds(new Set([selectedUserId]));
              setAdverStatusDetailData(campaigns.map(campaign => ({
                ...campaign,
                userId: selectedUserId,
                adverName: currentAdvertiser?.adverName,
                adverInfo: `${currentAdvertiser?.adverName ?? "-"}(${currentAdvertiser?.username ?? "-"})`
              })));
            } else {
              setSelectedAdvertiser(null);
              setSelectedIds(new Set());
              setAdverStatusDetailData([]);
            }
          } else {
            setSelectedIds(new Set());
            setAdverStatusDetailData([]);
          }
        } catch (error) {
          console.error("대시보드 광고주 현황 조회 실패:", error);
          setAdverStatusData([]);
          setAllCampaignData([]);
          setOverviewCache([]);

          toast.error(
              "대시보드 정보를 불러오는 중 오류가 발생했습니다.",
              {toastId: "dashboardAdvertiserLoadError"}
          );
        }

        return;
      }

      if (!tokenUserInfo?.id) {
        return;
      }

      try {
        const [campaignResponse, overviewResponse] = await Promise.all([
          retrieveUserAdvertiserCampaignStatus(
              tokenUserInfo.id,
              searchCondition
          ),
          selectedCampaign?.campaignId
              ? retrieveCommonReportsDetailByAdverCampId(
                  tokenUserInfo.id,
                  getCampaignDailyRequestCondition(searchCondition),
                  "campaign_daily",
                  selectedCampaign.campaignId
              )
              : retrieveAdverOverview(
                  tokenUserInfo.id,
                  searchCondition
              )
        ]);

        const campaigns = Array.isArray(campaignResponse)
            ? campaignResponse.filter(campaign => campaign?.step === "COMPLETED")
            : [];

        setAdverStatusData(campaigns);
        setAllCampaignData(campaigns);
        setTotalInfo({
          totalCount: campaigns.length
        });
        setOverviewCache(
            selectedCampaign?.campaignId
                ? (overviewResponse?.pagingCommonResponse?.content ?? []).map(item => ({
                  ...item,
                  historyDate: item?.historyDate ?? item?.statisticsDate
                }))
                : overviewResponse ?? []
        );
        setSelectedIds(new Set([tokenUserInfo.id]));
      } catch (error) {
        console.error("광고주 대시보드 조회 실패:", error);
        setAdverStatusData([]);
        setAllCampaignData([]);
        setOverviewCache([]);

        toast.error(
            "대시보드 정보를 불러오는 중 오류가 발생했습니다.",
            {toastId: "userDashboardLoadError"}
        );
      }
    };

    loadDashboard();

    setKeyword(searchCondition?.keyword ?? "");
    setSearchState({
      ...searchCondition
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchCondition, tokenUserInfo, selectedCampaign?.campaignId]);

  const handleData = (nextValues = {}) => {
    setSearchCondition({
      ...searchState,
      ...nextValues,
      keyword
    });
  };

  const handleSelectAdvertiser = async advertiser => {
    const userId = advertiser?.userId;

    if (!userId || isLoadingCampaigns) {
      return;
    }

    if (selectedAdvertiser?.userId === userId) {
      setSelectedAdvertiser(null);
      setSelectedCampaign(null);
      setAdverStatusDetailData([]);
      setSelectedIds(new Set());
      return;
    }

    setSelectedAdvertiser(advertiser);
    setSelectedCampaign(null);
    setAdverStatusDetailData([]);
    setSelectedIds(new Set([userId]));
    setIsLoadingCampaigns(true);

    try {
      const response = await retrieveAdvertiserCampaignStatus(
          userId,
          searchCondition
      );

      const campaigns = Array.isArray(response)
          ? response
          : [];

      setAdverStatusDetailData(
          campaigns
          .filter(campaign => campaign?.step === "COMPLETED")
          .map(campaign => ({
            ...campaign,
            userId,
            adverName: advertiser?.adverName,
            adverInfo:
                `${advertiser?.adverName ?? "-"}(${advertiser?.username ?? "-"})`
          }))
      );
    } catch (error) {
      console.error("광고주 캠페인 목록 조회 실패:", error);
      setAdverStatusDetailData([]);

      toast.error(
          "선택한 광고주의 캠페인 정보를 불러오는 중 오류가 발생했습니다.",
          {toastId: "dashboardCampaignDetailLoadError"}
      );
    } finally {
      setIsLoadingCampaigns(false);
    }
  };

  const handleAdvertiserSelectValue = event => {
    const userId = event.target.value;

    if (!userId) {
      if (selectedAdvertiser) {
        handleSelectAdvertiser(selectedAdvertiser);
      }
      return;
    }

    const advertiser = (adverStatusData ?? []).find(
        item => String(item?.userId) === String(userId)
    );

    if (advertiser && String(advertiser?.userId) !== String(selectedAdvertiser?.userId)) {
      handleSelectAdvertiser(advertiser);
    }
  };

  const selectableCampaigns =
      tokenUserInfo.role !== "NORMAL"
          ? (Array.isArray(adverStatusDetailData) ? adverStatusDetailData : [])
          : (Array.isArray(adverStatusData) ? adverStatusData : []);

  const handleCampaignSelect = campaign => {
    if (!campaign?.campaignId) {
      setSelectedCampaign(null);
      return;
    }

    setSelectedCampaign(campaign);
  };

  const handleCampaignSelectValue = event => {
    const campaignId = event.target.value;

    if (!campaignId) {
      setSelectedCampaign(null);
      return;
    }

    const campaign = selectableCampaigns.find(
        item => String(item?.campaignId) === String(campaignId)
    );

    setSelectedCampaign(campaign ?? null);
  };

  const advertiserCount =
      Array.isArray(adverStatusData)
          ? adverStatusData.length
          : 0;

  const sortedAdvertiserData = useMemo(
      () => (
        Array.isArray(adverStatusData)
            ? [...adverStatusData].sort((first, second) => {
              const nameComparison = String(first?.adverName ?? "")
              .localeCompare(
                  String(second?.adverName ?? ""),
                  "ko",
                  {numeric: true, sensitivity: "base"}
              );

              if (nameComparison !== 0) {
                return nameComparison;
              }

              return String(first?.username ?? "")
              .localeCompare(
                  String(second?.username ?? ""),
                  "ko",
                  {numeric: true, sensitivity: "base"}
              );
            })
            : []
      ),
      [adverStatusData]
  );

  const visibleCampaignCount =
      tokenUserInfo.role !== "NORMAL"
          ? (
              selectedAdvertiser
                  ? (
                      Array.isArray(adverStatusDetailData)
                          ? adverStatusDetailData.length
                          : 0
                  )
                  : (
                      Array.isArray(adverStatusData)
                          ? adverStatusData.reduce(
                              (total, advertiser) =>
                                  total +
                                  Number(
                                      advertiser?.campaignCount ?? 0
                                  ),
                              0
                          )
                          : 0
                  )
          )
          : Number(totalInfo?.totalCount ?? 0);

  const dashboardStatusContent = (
      <DashboardStatusDetails open>
        <DashboardStatusSummary>
          <PanelTitleArea><PanelAccent/><div>
            <PanelTitle>{tokenUserInfo.role !== "NORMAL" ? "광고주 및 캠페인 현황" : "캠페인 현황"}</PanelTitle>
            <PanelDescription>{tokenUserInfo.role !== "NORMAL" ? "광고주를 선택하여 운영 중인 캠페인 정보를 확인합니다." : "생성한 캠페인의 상태와 주요 정보를 확인합니다."}</PanelDescription>
          </div></PanelTitleArea>
          {/*<PanelCountGroup>*/}
          {/*  {tokenUserInfo.role !== "NORMAL" && <PanelCountItem><PanelCountLabel>광고주</PanelCountLabel><PanelCountValue>{advertiserCount}</PanelCountValue></PanelCountItem>}*/}
          {/*  <PanelCountItem $accent><PanelCountLabel>캠페인</PanelCountLabel><PanelCountValue $accent>{visibleCampaignCount}</PanelCountValue></PanelCountItem>*/}
          {/*</PanelCountGroup>*/}
        </DashboardStatusSummary>
        <DashboardPanelBody>
          {tokenUserInfo.role !== "NORMAL" ? (
              <AdvertiserCampaignStatus advertiserData={sortedAdvertiserData} campaignData={adverStatusDetailData} selectedAdvertiser={selectedAdvertiser} selectedCampaign={selectedCampaign} isLoadingCampaigns={isLoadingCampaigns} onSelectAdvertiser={handleSelectAdvertiser} onSelectCampaign={handleCampaignSelect}/>
          ) : (
              <UserCampaignStatus campaignData={adverStatusData} selectedCampaign={selectedCampaign} onSelectCampaign={handleCampaignSelect}/>
          )}
        </DashboardPanelBody>
      </DashboardStatusDetails>
  );

  return (
      <>
        <DashboardStatisticsSection>
            <ChartComponent
                campaignSelected={Boolean(selectedCampaign)}
                advertiserCount={tokenUserInfo.role !== "NORMAL" ? advertiserCount : 1}
                campaignCount={visibleCampaignCount}
                campaignData={tokenUserInfo.role !== "NORMAL"
                    ? (selectedAdvertiser ? adverStatusDetailData : allCampaignData)
                    : adverStatusData}
                selectionControl={
                  <DashboardSelectionFilters>
                    {tokenUserInfo.role !== "NORMAL" && (
                        <DashboardSelectField>
                          <DashboardSelect
                              value={selectedAdvertiser?.userId ?? ""}
                              onChange={handleAdvertiserSelectValue}
                              aria-label="광고주"
                          >
                            <option value="">광고주 전체</option>
                            {sortedAdvertiserData.map(advertiser => (
                                <option key={advertiser?.userId} value={advertiser?.userId}>
                                  {advertiser?.adverName ?? advertiser?.username ?? "-"}
                                </option>
                            ))}
                          </DashboardSelect>
                        </DashboardSelectField>
                    )}
                    <DashboardSelectField>
                      <DashboardSelect
                          value={selectedCampaign?.campaignId ?? ""}
                          onChange={handleCampaignSelectValue}
                          aria-label="캠페인"
                          disabled={
                            tokenUserInfo.role !== "NORMAL" &&
                            !selectedAdvertiser
                          }
                      >
                        <option value="">
                          {tokenUserInfo.role !== "NORMAL" && !selectedAdvertiser
                              ? "광고주를 먼저 선택해주세요"
                              : "캠페인 전체"}
                        </option>
                        {selectableCampaigns.map(campaign => (
                            <option
                                key={campaign?.campaignId}
                                value={campaign?.campaignId}
                            >
                              {campaign?.campaignName ?? campaign?.name ?? "-"}
                            </option>
                        ))}
                      </DashboardSelect>
                    </DashboardSelectField>
                  </DashboardSelectionFilters>
                }
                statusContent={dashboardStatusContent}
                periodControl={
                  <DashBoardCondition
                      role={tokenUserInfo.role}
                      productType={productType}
                      targetingType={[]}
                      handleData={handleData}
                      keyword={keyword}
                      setKeyword={setKeyword}
                      searchState={searchState}
                      setSearchState={setSearchState}
                      defaultOpen={true}
                  />
                }
            />
        </DashboardStatisticsSection>

        {false && (<DashboardPanel>
          <DashboardPanelHeader>
            <PanelTitleArea>
              <PanelAccent/>

              <div>
                <PanelTitle>
                  {tokenUserInfo.role !== "NORMAL"
                      ? "광고주 및 캠페인 현황"
                      : "캠페인 현황"}
                </PanelTitle>

                <PanelDescription>
                  {tokenUserInfo.role !== "NORMAL"
                      ? "광고주를 선택하여 운영 중인 캠페인 정보를 확인합니다."
                      : "생성한 캠페인의 상태와 주요 정보를 확인합니다."}
                </PanelDescription>
              </div>
            </PanelTitleArea>

            <PanelCountGroup>
              {tokenUserInfo.role !== "NORMAL" && (
                  <PanelCountItem>
                    <PanelCountLabel>
                      광고주
                    </PanelCountLabel>

                    <PanelCountValue>
                      {advertiserCount}
                    </PanelCountValue>
                  </PanelCountItem>
              )}

              <PanelCountItem $accent>
                <PanelCountLabel>
                  캠페인
                </PanelCountLabel>

                <PanelCountValue $accent>
                  {visibleCampaignCount}
                </PanelCountValue>
              </PanelCountItem>
            </PanelCountGroup>
          </DashboardPanelHeader>

          <DashboardPanelBody>
            {tokenUserInfo.role !== "NORMAL" ? (
                <AdvertiserCampaignStatus
                    advertiserData={adverStatusData}
                    campaignData={adverStatusDetailData}
                    selectedAdvertiser={selectedAdvertiser}
                    isLoadingCampaigns={isLoadingCampaigns}
                    onSelectAdvertiser={handleSelectAdvertiser}
                />
            ) : (
                <UserCampaignTableCard>
                  <Table
                      columns={userCampaignListColumn}
                      totalCount={[totalInfo.totalCount, "캠페인"]}
                      rowHeight={null}
                      defaultSortInfo={{name: "username", dir: -1}}
                      data={adverStatusData}
                  />
                </UserCampaignTableCard>
            )}
          </DashboardPanelBody>
        </DashboardPanel>)}

        {tokenUserInfo.role === "NORMAL" && <NoticeUser/>}
      </>
  );
}

export default DashBoardIndex;

const DashboardNoticeCard = styled.section`
  margin-top: 16px;
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, 0.045);
`;

const DashboardNoticeHeader = styled.header`
  display: flex;
  min-height: 72px;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 15px 20px;
  border-bottom: 1px solid #edf0f2;
  background: #f9fafb;
`;

const NoticeAllButton = styled.button`
  display: inline-flex;
  height: 32px;
  flex: 0 0 auto;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #727a82;
  font-family: inherit;
  font-size: var(--font-size-12);
  font-weight: 700;
  cursor: pointer;

  span {
    color: #f5811f;
    font-size: var(--font-size-15);
  }

  &:hover {
    background: #fff4e8;
    color: #d96500;
  }
`;

const DashboardNoticeBody = styled.div`
  padding: 8px 20px 16px;

  .InovuaReactDataGrid,
  .InovuaReactDataGrid__body,
  .InovuaReactDataGrid__virtual-list {
    border: 0 !important;
    box-shadow: none !important;
  }

  .InovuaReactDataGrid__row,
  .InovuaReactDataGrid__row-cell-wrap,
  .InovuaReactDataGrid__cell {
    border: 0 !important;
  }

  @media (max-width: 700px) {
    padding: 6px 14px 14px;
  }
`;

const DashboardPanel = styled.section`
  margin-bottom: 20px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  border-radius: 9px;
  background-color: #fff;
`;

const DashboardPanelHeader = styled.header`
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 17px 20px;
  border-bottom: 1px solid #eeeeee;
  background-color: #f9fafb;

  @media (max-width: 760px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
`;

const PanelTitleArea = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 11px;
`;

const PanelAccent = styled.span`
  width: 4px;
  height: 34px;
  flex: 0 0 4px;
  border-radius: 2px;
  background-color: #f5811f;
`;

const PanelTitle = styled.div`
  margin-bottom: 5px;
  color: #222;
  font-size: var(--font-size-17);
  font-weight: 700;
`;

const PanelDescription = styled.div`
  color: #888;
  font-size: var(--font-size-12);
  line-height: 1.5;
`;

const PanelCountGroup = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
`;

const PanelCountItem = styled.div`
  display: inline-flex;
  min-width: 66px;
  min-height: 30px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 10px;
  border: 1px solid
  ${({$accent}) => $accent ? "#f1d4c2" : "#e5e5e5"};
  border-radius: 17px;
  background-color:
          ${({$accent}) => $accent ? "#fff4e8" : "#fff"};
`;

const PanelCountLabel = styled.span`
  color: #888;
  font-size: var(--font-size-11);
`;

const PanelCountValue = styled.strong`
  color:
          ${({$accent}) => $accent ? "#f5811f" : "#555"};
  font-size: var(--font-size-13);
`;

const DashboardPanelBody = styled.div`
  padding: 20px;

  @media (max-width: 700px) {
    padding: 15px;
  }
`;

const PlatformStatusContent = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: minmax(0, 1.7fr) minmax(300px, .9fr);
  gap: 16px;

  @media (max-width: 1050px) {
    grid-template-columns: 1fr;
  }
`;

const DashboardFilterRow = styled.div`
  display: flex;
  grid-column: 1 / -1;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  order: 0;
`;

const DashboardSelectionFilters = styled.div`
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 700px) {
    width: 100%;
  }
`;

const DashboardSelectField = styled.label`
  display: flex;
  min-width: 0;
`;

const DashboardSelect = styled.select`
  width: 190px;
  height: 47px;
  box-sizing: border-box;
  padding: 0 34px 0 39px;
  border: 1px solid #dfe3e7;
  border-radius: 7px;
  appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  background-image:
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 24 24'%3E%3Cpath d='M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm-7 8a7 7 0 0 1 14 0' fill='none' stroke='%23f5811f' stroke-width='1.8' stroke-linecap='round'/%3E%3C/svg%3E"),
          url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5 6 6.5l5-5' fill='none' stroke='%23858c94' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat, no-repeat;
  background-position: left 12px center, right 12px center;
  background-size: 18px 18px, 12px 8px;
  color: #444;
  font-size: var(--font-size-13);
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 7px rgba(31, 41, 55, .035);
  transition: border-color .2s ease, box-shadow .2s ease, background-color .2s ease;

  &:hover:not(:disabled) {
    border-color: #f1b98d;
    background-color: #fffaf6;
  }

  &:focus {
    border-color: #f5811f;
    outline: none;
    box-shadow: 0 0 0 3px rgba(245, 129, 31, .1);
  }

  &:disabled {
    background-color: #f5f6f7;
    color: #a5abb1;
    cursor: not-allowed;
  }

  @media (max-width: 700px) {
    width: min(100%, 220px);
  }
`;

const PlatformSummaryRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;

  @media (max-width: 650px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const PlatformSummaryText = styled.div`
  color: #777;
  font-size: var(--font-size-13);
  line-height: 1.5;
`;

const ChartSelectionBadge = styled.span`
  display: inline-flex;
  min-height: 27px;
  flex: 0 0 auto;
  align-items: center;
  padding: 0 10px;
  border: 1px solid #f1d4c2;
  border-radius: 14px;
  background-color: #fffaf6;
  color: #f5811f;
  font-size: var(--font-size-11);
  font-weight: 700;
`;

const MetricGrid = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 15px 4px;
  flex-wrap: wrap;

  @media (max-width: 980px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const MetricCard = styled.button`
  position: relative;
  min-width: auto;
  min-height: 30px;
  padding: 0 8px;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: #444;
  text-align: left;
  cursor: pointer;
  opacity: ${({$active}) => $active ? 1 : .4};
  transition:
          background-color 0.15s ease,
          opacity 0.15s ease;

  &:hover {
    background-color: #f7f8f9;
    opacity: 1;
  }

  &:focus-visible {
    outline: 1px solid #f5811f;
    outline-offset: 2px;
  }
`;

const MetricLabelGroup = styled.span`
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 7px;
`;

const MetricColorDot = styled.span`
  width: 8px;
  height: 8px;
  flex: 0 0 8px;
  border: 1px solid
  ${({$seriesColor}) => $seriesColor};
  border-radius: 2px;
  background-color:
          ${({$active, $seriesColor}) =>
                  $active ? $seriesColor : "#fff"};
`;

const MetricLabel = styled.span`
  color: #555;
  font-size: var(--font-size-13);
  font-weight: 600;
`;

const ChartPanel = styled.section`
  grid-column: 1;
  order: 2;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, .04);

  @media (max-width: 1050px) {
    grid-column: 1;
  }
`;

const ChartPanelHeader = styled.div`
  display: flex;
  min-height: 52px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 9px 15px;
  border-bottom: 1px solid #eeeeee;
  background-color: #fff;
`;

const ChartPanelTitleGroup = styled.div`
  min-width: 0;
`;

const ChartPanelTitle = styled.div`
  margin-bottom: 4px;
  color: #333;
  font-size: var(--font-size-14);
  font-weight: 700;
`;

const ChartPanelDescription = styled.div`
  color: #999;
  font-size: var(--font-size-11);
  line-height: 1.4;
`;

const ActiveMetricCount = styled.span`
  display: inline-flex;
  min-width: 52px;
  height: 25px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 9px;
  border: 1px solid #f1d4c2;
  border-radius: 13px;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: var(--font-size-11);
  font-weight: 700;
`;

const ChartArea = styled.div`
  width: 100%;
  height: 280px;
  padding: 4px 12px 8px;

  @media (max-width: 700px) {
    height: 200px;
  }
`;

const DashboardStatusDetails = styled.details`
  grid-column: 1 / -1;
  order: 4;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  border-radius: 9px;
  background: #fff;
`;

const DashboardStatusSummary = styled.summary`
  display: flex;
  min-height: 72px;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 20px;
  border-bottom: 1px solid transparent;
  background: #fff;
  cursor: pointer;
  list-style: none;
  transition: background-color .16s ease, border-color .16s ease;

  &::-webkit-details-marker { display: none; }
  &::after {
    color: #f5811f;
    font-size: var(--font-size-17);
    content: "▾";
    transition: transform 0.15s ease;
  }
  ${DashboardStatusDetails}[open] & {
    border-bottom-color: #eeeeee;
    background: #f9fafb;
  }
  ${DashboardStatusDetails}[open] &::after { transform: rotate(180deg); }
`;

const ChartEmptyState = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;

const ChartEmptyIcon = styled.span`
  display: inline-flex;
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 50%;
  background-color: #f5f5f5;
  color: #aaa;
`;

const ChartEmptyTitle = styled.div`
  margin-bottom: 6px;
  color: #555;
  font-size: var(--font-size-14);
  font-weight: 700;
`;

const ChartEmptyDescription = styled.div`
  color: #999;
  font-size: var(--font-size-11);
`;

const StatusLayout = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 250px minmax(0, 1fr);
  gap: 16px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

const StatusSection = styled.section`
  width: 100%;
`;

const StatusSectionHeader = styled.div`
  display: flex;
  min-height: 56px;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 10px;

  @media (max-width: 760px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 9px;
  }
`;

const StatusTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 11px;
`;

const StatusStepNumber = styled.span`
  display: inline-flex;
  width: 30px;
  height: 30px;
  flex: 0 0 30px;
  align-items: center;
  justify-content: center;
  border: 1px solid
  ${({$inactive}) => $inactive ? "#d8d8d8" : "#f5811f"};
  border-radius: 50%;
  background-color:
          ${({$inactive}) => $inactive ? "#f5f5f5" : "#fff4e8"};
  color:
          ${({$inactive}) => $inactive ? "#999" : "#f5811f"};
  font-size: var(--font-size-13);
  font-weight: 700;
`;

const StatusTitle = styled.div`
  margin-bottom: 4px;
  color: #333;
  font-size: var(--font-size-15);
  font-weight: 700;
`;

const StatusDescription = styled.div`
  color: #888;
  font-size: var(--font-size-12);
  line-height: 1.45;
`;

const StatusCountBadge = styled.span`
  display: inline-flex;
  min-width: 44px;
  height: 26px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  border: 1px solid #f1d4c2;
  border-radius: 13px;
  background-color: #fff4e8;
  color: #f5811f;
  font-size: var(--font-size-12);
  font-weight: 700;
`;

const DashboardStatisticsSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 20px;
`;

const DashboardSummaryGrid = styled.div`
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  order: 1;

  @media (max-width: 980px) { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 560px) { grid-template-columns: 1fr; }
`;

const DashboardOverviewRow = styled.div`
  display: contents;
`;

const summaryTone = {
  orange: {main: '#f5811f', soft: '#fff7ef', border: '#f6d5b9', shadow: 'rgba(245,129,31,.14)'},
  blue: {main: '#4f7fd6', soft: '#f3f7ff', border: '#cedcf5', shadow: 'rgba(79,127,214,.14)'},
  green: {main: '#2fae8f', soft: '#f0faf7', border: '#c8e9df', shadow: 'rgba(47,174,143,.14)'},
  purple: {main: '#7668dc', soft: '#f5f3ff', border: '#dcd7f7', shadow: 'rgba(118,104,220,.14)'}
};

const DashboardSummaryCard = styled.div`
  position: relative;
  min-width: 0;
  min-height: 88px;
  box-sizing: border-box;
  padding: 10px 13px;
  overflow: hidden;
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 16px rgba(31, 41, 55, .045);
  transition: transform .16s ease, box-shadow .16s ease;

  &::after {
    position: absolute;
    top: -55px;
    left: -55px;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    background: ${({$tone}) => summaryTone[$tone]?.main || '#ddd'};
    content: '';
    opacity: .045;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px ${({$tone}) => summaryTone[$tone]?.shadow || 'rgba(31,41,55,.08)'};
  }
`;

const SummaryCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 3px;
`;

const SummaryCardIcon = styled.span`
  display: inline-flex;
  width: 32px;
  height: 32px;
  min-width: 32px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  order: 2;
  margin-left: auto;
  padding: 7px;
  border-radius: 50%;
  background: ${({$tone}) => summaryTone[$tone]?.soft || '#f5f5f5'};
  color: ${({$tone}) => summaryTone[$tone]?.main || '#888'};

  svg { width: 17px; height: 17px; fill: currentColor; }
`;

const SummaryCardLabel = styled.div`
  order: 1;
  color: #626a72;
  font-size: var(--font-size-13);
  font-weight: 700;
`;

const SummaryCardValue = styled.strong`
  display: block;
  overflow: hidden;
  color: #2f363d;
  font-size: var(--font-size-20);
  font-weight: 800;
  letter-spacing: -.4px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const SummaryCardGuide = styled.div`
  margin-top: 4px;
  color: #9299a0;
  font-size: var(--font-size-11);
`;

const CampaignComparisonPanel = styled.section`
  grid-column: 2;
  order: 3;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31, 41, 55, .04);

  @media (max-width: 1050px) {
    grid-column: 1;
  }
`;

const CampaignMetricGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;
  padding: 10px 16px 12px;
`;

const ComparisonHeaderControls = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
`;

const ComparisonTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;

  ${ChartPanelTitle} { margin-bottom: 0; }
  ${ActiveMetricCount} {
    min-width: 43px;
    height: 20px;
    padding: 0 7px;
    font-size: var(--font-size-10);
  }
`;

const ComparisonMetricSelect = styled.select`
  min-width: 78px;
  height: 32px;
  padding: 0 28px 0 10px;
  border: 1px solid #dfe3e7;
  border-radius: 6px;
  background: #fff;
  color: #555;
  font-size: var(--font-size-12);
  font-weight: 600;
  cursor: pointer;

  &:focus {
    border-color: #f5811f;
    outline: none;
    box-shadow: 0 0 0 3px rgba(245, 129, 31, .1);
  }
`;

const CampaignMetricGroup = styled.div`
  min-width: 0;
`;

const CampaignMetricTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
  color: #444;
  font-size: var(--font-size-13);

  span { color: #999; font-size: var(--font-size-11); }
`;

const CampaignBars = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const CampaignBarRow = styled.div`
  display: grid;
  width: 100%;
  min-height: 54px;
  grid-template-columns: 26px minmax(0, 1fr) 72px 92px;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #edf0f2;

  &:last-child { border-bottom: 0; }

  @media (max-width: 560px) {
    grid-template-columns: 24px minmax(0, 1fr) 62px;
  }
`;

const CampaignRank = styled.span`
  color: ${({$rank}) => (
    ['#f5811f', '#4f7fd6', '#2fae8f', '#7668dc', '#e66a7a'][$rank] ??
    '#8b929a'
  )};
  font-size: var(--font-size-19);
  font-weight: 800;
  text-align: center;
`;

const CampaignNameGroup = styled.span`
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 4px;
`;

const CampaignBarName = styled.span`
  overflow: hidden;
  color: #394049;
  font-size: var(--font-size-12);
  font-weight: 650;
  line-height: 1.35;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CampaignAdvertiserName = styled.span`
  overflow: hidden;
  color: #9299a0;
  font-size: var(--font-size-10);
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CampaignMiniChart = styled.span`
  display: block;
  width: 92px;
  height: 24px;

  svg { width: 100%; height: 100%; overflow: visible; }
  polyline {
    fill: none;
    stroke: ${({$rank}) => (
      ['#f5811f', '#4f7fd6', '#2fae8f', '#7668dc', '#e66a7a'][$rank] ??
      '#8b929a'
    )};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
  }

  @media (max-width: 560px) { display: none; }
`;

const CampaignBarValue = styled.span`
  color: #4f565d;
  font-size: var(--font-size-11);
  font-weight: 700;
  text-align: right;
`;

const ComparisonEmpty = styled.div`
  display: flex;
  min-height: 190px;
  align-items: center;
  justify-content: center;
  padding: 24px;
  color: #999;
  font-size: var(--font-size-12);
  text-align: center;
`;

const CampaignTableCard = styled.div`
  min-height: 242px;
  overflow: hidden;
  border: ${({$active}) => $active ? "0" : "1px solid #e5e5e5"};
  border-left: 3px solid
  ${({$active}) => $active ? "#f5811f" : "#e5e5e5"};
  border-radius: 0 8px 8px 0;
  background-color: #fff;
`;

const SelectedAdvertiserSummary = styled.div`
  display: flex;
  min-height: 34px;
  align-items: center;
  gap: 7px;
  padding: 0 12px;
  border: 1px solid #f1d4c2;
  border-radius: 17px;
  background-color: #fffaf6;
`;

const SummaryLabel = styled.span`
  color: #888;
  font-size: var(--font-size-11);
`;

const SummaryValue = styled.strong`
  color: #f5811f;
  font-size: var(--font-size-12);
`;

const SummaryDivider = styled.span`
  width: 1px;
  height: 11px;
  background-color: #e3c9b7;
`;

const SummarySubValue = styled.span`
  color: #777;
  font-size: var(--font-size-11);
`;

const CampaignGridWrap = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 0;
  border-radius: 0 8px 8px 0;
`;

const CampaignEmptyState = styled.div`
  display: flex;
  min-height: 260px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 32px 20px;
  text-align: center;
`;

const EmptyIcon = styled.span`
  display: inline-flex;
  width: 56px;
  height: 56px;
  align-items: center;
  justify-content: center;
  margin-bottom: 13px;
  border-radius: 50%;
  background-color: #f5f5f5;
  color: #aaa;
`;

const EmptyTitle = styled.div`
  margin-bottom: 7px;
  color: #555;
  font-size: var(--font-size-15);
  font-weight: 700;
`;

const EmptyDescription = styled.div`
  color: #999;
  font-size: var(--font-size-12);
  line-height: 1.5;
`;

const CampaignLoading = styled.div`
  display: flex;
  min-height: 260px;
  align-items: center;
  justify-content: center;
  gap: 9px;
  color: #777;
  font-size: var(--font-size-13);
`;

const LoadingSpinner = styled.span`
  width: 18px;
  height: 18px;
  box-sizing: border-box;
  border: 2px solid #f3d5c0;
  border-top-color: #f5811f;
  border-radius: 50%;
  animation: dashboard-campaign-spin 0.7s linear infinite;

  @keyframes dashboard-campaign-spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const UserCampaignTableCard = styled.div`
  width: 100%;
  min-height: 240px;
  overflow-x: auto;
  border: 0;
  border-radius: 0;
  background-color: transparent;
`;
